import apiConfig from "../Environments/environment";
import ErrorHandling from "../ErrorHandling/errorHandling";
import filePath from '../csvFile/combined.csv';
import Papa from 'papaparse';


import {
  environment,
} from '../Environments/environment';



const {
  REACT_APP_API_PATH:apiPath,
} = process.env;

const {
  REACT_APP_API_PORT:apiPort,
} = process.env;

const {
  REACT_APP_FLASK_PORT:flaskPort,
} = process.env;


const {
  REACT_APP_yoloEndpoint: yoloEndpoint,
} = process.env;

const tokenFromLocalStorage = localStorage.getItem('token');

const header = new Headers({
  'content-type': 'application/json',
})


export const imageHeader = {
  'content-type': 'application/json',
  // 'Authorization': tokenFromLocalStorage
}



// Login API 
export async function bearerToken(obj) {

  let result = await fetch(`${apiPath}:${apiPort}/tokens/authenticate`,
    {
      method: 'POST',
      headers: header,
      body: JSON.stringify(obj),
    });

  const handledError = await ErrorHandling(result);
  return handledError;
};

// INTERIM CI/CD/TEST

// Login API 
// export async function Login(obj) {

//   let result = await fetch(`${apiPath}/login`,
//     {
//       method: 'POST',
//       headers: header,
//       body: JSON.stringify(obj),
//     });
//   console.log("login api result",result);

//   const handledError = await ErrorHandling(result);
//   return handledError;
// };


// replacing login API with direct frontend validation
export async function Login(obj) {
  const { emailAddress, password } = obj;

  // Load credentials from .env
  const correctEmail = process.env.REACT_APP_ADMIN_EMAIL;
  const correctPassword = process.env.REACT_APP_ADMIN_PASSWORD;
  const accessToken = process.env.REACT_APP_ACCESS_TOKEN || null;


  // Simulate small delay (like network latency)
  await new Promise(resolve => setTimeout(resolve, 300));
  // Validation logic
  if (emailAddress === correctEmail) {
    if (password === correctPassword) {
      //  Success
      return {
        success: true,
        data: {
          message: 'Login successful',
          accessToken: accessToken
        }
      };
    } else {
      // Wrong password
      return {
        success: false,
        data: { message: 'Invalid email or password' }
      };
    }
  } else {
    //  Wrong email
    return {
      success: false,
      data: { message: 'Invalid email or password' }
    };
  }
}




// Login API 
export async function getEventsApi(apiData) {

  let { offset, limit, queryValues } = apiData;

  const tokenFromLocalStorage = localStorage.getItem('token');

  let result = await fetch(`${apiPath}:${apiPort}/event/all?offset=${offset}&limit=${limit}`,


    {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        'Authorization': tokenFromLocalStorage
      },
      body: JSON.stringify(queryValues)
    },

  );

  const handledError = await ErrorHandling(result);
  return handledError;
};

// analytics API
// export async function getAnalytics(obj) {
//   const tokenFromLocalStorage = localStorage.getItem('token');
//   let result = await fetch(`${apiPath}/analytics`,
//     {
//       method: 'GET',
//       headers: {
//         'content-type': 'application/json',
//         'Authorization': tokenFromLocalStorage
//       },
//     });
//   const handledError = await ErrorHandling(result);
//   console.log("analytics",handledError);
//   return handledError;
// };


// replace fetching from api with directly fetching from frontend
export async function getAnalytics() {
  try {
    const response = await fetch(filePath);
    const csvText = await response.text();

    // Parse CSV into JS objects
    const parsed = Papa.parse(csvText, { header: true });
    const df = parsed.data;

    const data = {};
    const td = new Date();
    const today = td.toISOString().split("T")[0]; // 'YYYY-MM-DD'

    const KPI_TYPES = [
      "Baggage Detection",
      "Number Plate",
      "Face Recognition",
      "FireSmoke Detection",
      "PPE Detection",
      "ForeignMaterial Detection"
    ];

    for (let kpi of KPI_TYPES) {
      let x = df.filter((row) => row.kpiType === kpi);
      const kpiKey = kpi.replace(" ", "_");

      if (kpi !== "FireSmoke Detection") {
        const total = x.length;
        const last30Days = x.filter((row) => {
          const d = new Date(row.detectionDate);
          return (td - d) / (1000 * 60 * 60 * 24) <= 30;
        }).length;
        const todayCount = x.filter(
          (row) => row.detectionDate === today
        ).length;

        if (kpi === "Baggage Detection") {
          x = x.filter((row) => row.hasWpn === "True" || row.hasWpn === true);
        } else if (kpi === "Number Plate") {
          x = x.filter((row) => row.detectionName !== "Not Detected");
        } else if (kpi === "Face Recognition") {
          x = x.filter(
            (row) =>
              row.detectionName !== "Not Detected" &&
              row.detectionName !== "Unknown"
          );
        }

        const totalFiltered = x.length;
        const last30Filtered = x.filter((row) => {
          const d = new Date(row.detectionDate);
          return (td - d) / (1000 * 60 * 60 * 24) <= 30;
        }).length;
        const todayFiltered = x.filter(
          (row) => row.detectionDate === today
        ).length;

        data[kpiKey] = [
          total,
          last30Days,
          todayCount,
          totalFiltered,
          last30Filtered,
          todayFiltered,
        ];
      } else {
        // FireSmoke Detection
        const fire = x.filter((row) =>
          (row.detectionName || "").toLowerCase().includes("fire")
        );
        const smoke = x.filter((row) =>
          (row.detectionName || "").toLowerCase().includes("smoke")
        );

        const fireTotal = fire.length;
        const fireLast30 = fire.filter((row) => {
          const d = new Date(row.detectionDate);
          return (td - d) / (1000 * 60 * 60 * 24) <= 30;
        }).length;
        const fireToday = fire.filter(
          (row) => row.detectionDate === today
        ).length;

        const smokeTotal = smoke.length;
        const smokeLast30 = smoke.filter((row) => {
          const d = new Date(row.detectionDate);
          return (td - d) / (1000 * 60 * 60 * 24) <= 30;
        }).length;
        const smokeToday = smoke.filter(
          (row) => row.detectionDate === today
        ).length;

        data[kpiKey] = [
          fireTotal,
          fireLast30,
          fireToday,
          smokeTotal,
          smokeLast30,
          smokeToday,
        ];
      }
    }

    console.log("Frontend analytics data:", data);
    return data;
  } catch (error) {
    console.error("Error loading analytics:", error);
    throw error;
  }
}



// het events by id 
export async function getEventsApiByID(obj) {

  const tokenFromLocalStorage = localStorage.getItem('token');

  let result = await fetch(`${apiPath}:${apiPort}/event?id=${obj}`,



    {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'Authorization': tokenFromLocalStorage
      },
    });

  const handledError = await ErrorHandling(result);
  return handledError;
};



// delete events
export async function deleteEventApi(obj) {

  const tokenFromLocalStorage = localStorage.getItem('token');

  let result = await fetch(`${apiPath}:${flaskPort}/validate_entry`,


    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'Authorization': tokenFromLocalStorage
      },
      body: JSON.stringify(obj)
    });

  const handledError = await ErrorHandling(result);
  return handledError;
};



// Create events
export async function createEventApi(data) {

  const tokenFromLocalStorage = localStorage.getItem('token');


  let result = await fetch(`${apiPath}:${flaskPort}/manual_entry`,
    {
      method: 'POST',
      headers: {
        // 'content-type': 'multipart/form-data',
        'Authorization': tokenFromLocalStorage
      },
      body: data
    });

  const handledError = await ErrorHandling(result);
  return handledError;
};



// Create events
export async function uploadImageApi(data) {

  const tokenFromLocalStorage = localStorage.getItem('token');

  const useFile = data instanceof File
    ? data
    : data.originFileObj

  const formData = new FormData();

  formData.append('file', useFile);
  formData.append('blob', '');
  formData.append('location', '');
  formData.append('modeltype', '');


  // formData.append('model_choice', 'cap-uncapped');
  // headers.append('Origin','http://localhost:3000');

  let result = await fetch(yoloEndpoint,
    {
      method: 'POST',
      headers: {},
      body: formData
    });
  let message = await result.text();

  return {
    success: true,
    message,
  };
};

//Validate API
export async function validateUID(body) {

  const tokenFromLocalStorage = localStorage.getItem('token');

  let result = await fetch(`${apiPath}:${flaskPort}/validate_entry`,

    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'Authorization': tokenFromLocalStorage
      },
      body: JSON.stringify(body)
    },

  );

  const handledError = await ErrorHandling(result);
  return handledError;
};

//Validate API
export async function blockOptionsAPI() {

  const tokenFromLocalStorage = localStorage.getItem('token');

  let result = await fetch(`${apiPath}:${apiPort}/event/block-options`,

    {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'Authorization': tokenFromLocalStorage
      },
    },

  );

  const handledError = await ErrorHandling(result);
  return handledError;
};



